import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Fade,
  IconButton,
  Paper,
  Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import TrashIcon from '@material-ui/icons/Delete';
import FolderOpen from '@material-ui/icons/FolderOpen';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import AcertoCoparticipacaoApi from '../../api/AcertoCoparticipacaoApi';
import AnexoApi from '../../api/AnexoApi';
import LinearProgressBlockScreen from './LinearProgressBlockScreen';
import GuiaApi from '../../api/GuiaApi';

const styles = theme => ({
  paper: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  body: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  selectTipo: {
    margin: theme.spacing(1),
    marginLeft: theme.spacing(5),
    width: 830,
  },
  divSelecaoArquivo: {
    width: '1200px',
    display: 'table-cell'
  },
  typography: {
    display: 'inline',
    margin: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  divBotoes: {
    display: 'table-cell'
  },
  fontTableLink: {
    fontSize: 12,
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underline'
  },
});

class FormDialogAnexarArquivos extends React.Component {
  anexoApi = new AnexoApi();
  guiaApi = new GuiaApi();
  state= {
    arquivos: this.props.arquivos === undefined ? [] : this.props.arquivos,
    fetching: false,
    nomeArquivo: '',
    selectedFile: null,
  }
  componentDidMount = async () => {
    this.setState({fetching: true});
    let arquivos = [];
    this.state.arquivos.map(res => {
      const { codGuiaArquivoAnexo, nomArquivo, txtObjetoGed } = res;
      let brancoAcoes = '';
      arquivos.push(Object.values({ codGuiaArquivoAnexo, nomArquivo, txtObjetoGed, brancoAcoes }));
    });
    await this.setState({arquivos: arquivos, fetching: false});
  }
  handleFileClick = () => {
    document.getElementById('contained-button-file').value = '';
  }
  handleFileSelection = files => {
    this.setState({selectedFile: files[0], nomeArquivo: files[0].name});
  };
  handleClickUpload = async () => {
    this.setState({fetching: true});
    const formData = new FormData();
    formData.append('file', this.state.selectedFile);
    formData.append('tipo', this.state.selectedFile.type);
    let txtObjetoGed = await this.anexoApi.upload(formData);
    await this.guiaApi.anexarArquivo(this.props.codLoteGuia, this.props.codGuia, this.state.nomeArquivo, txtObjetoGed.data);
    await this.consultarArquivos();
    await this.props.handleSave();
    this.setState({fetching: false, nomeArquivo: ''});
  };
  handleClickExcluirArquivo = async (event, tableMeta) => {
    this.setState({fetching: true});
    await this.anexoApi.delete(this.state.arquivos[tableMeta.rowIndex][2], this.state.arquivos[tableMeta.rowIndex][1]);
    await this.guiaApi.deletarArquivo(this.props.codLoteGuia, this.props.codGuia, this.state.arquivos[tableMeta.rowIndex][0]);
    await this.consultarArquivos();
    await this.props.handleSave();
    this.setState({fetching: false, nomeArquivo: ''});
  };
  handleClickDownloadArquivo = async (event, tableMeta) => {
    this.setState({fetching: true});
    await this.anexoApi.download(this.state.arquivos[tableMeta.rowIndex][2], this.state.arquivos[tableMeta.rowIndex][1]);
    this.setState({fetching: false, nomeArquivo: ''});
  };
  consultarArquivos = async () => {
    let arquivosNovo = await this.guiaApi.consultarArquivos(this.props.codLoteGuia, this.props.codGuia);
    let arquivos = [];
    arquivosNovo.map(res => {
      const { codGuiaArquivoAnexo, nomArquivo, txtObjetoGed } = res;
      let brancoAcoes = '';
      arquivos.push(Object.values({ codGuiaArquivoAnexo, nomArquivo, txtObjetoGed, brancoAcoes }));
    });
    await this.setState({arquivos: arquivos});
  }

  render () {
    const options = {
      print: false,
      download: false,
      search: false,
      viewColumns: false,
      filter: false,
      selectableRows: 'none',
      rowHover: false,
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline'}}>registro(s) selecionado(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'codArquivo',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Nome',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <Typography
                className={classes.fontTableLink}
                title='Clique no link para baixar o arquivo...'
                onClick={event => this.handleClickDownloadArquivo(event, tableMeta)}>
                {value}
              </Typography>
            );
          },
        }
      },
      {
        name: 'Id Objeto GED',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Excluir',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              <IconButton
                id={'menuButton'}
                className={classes.iconButton}
                disabled={!this.props.modoEdicaoGuia}
                aria-label='More'
                aria-owns={open ? 'long-menu' : null}
                aria-haspopup='true'
                title={'Excluir arquivo da lista'}
                onClick={event => this.handleClickExcluirArquivo(event, tableMeta)}
              >
                <TrashIcon fontSize='medium' />
              </IconButton>
            );
          },
        }
      },
    ];

    const { classes, open, handleClose, titulo } = this.props;
    const { arquivos, nomeArquivo, fetching } = this.state;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='md'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            {titulo}
          </DialogTitle>
          <DialogContent>
            {this.props.modoEdicaoGuia &&
            <DialogContentText id='alert-dialog-description'>
              Selecione um arquivo para anexar à Guia {this.props.codGuia}
            </DialogContentText>
            } 
            <Paper className={classes.body} elevation={1}>
              <div className={classes.divSelecaoArquivo}>
                <input
                  style={{display: 'none'}}
                  accept='.pdf,.jpeg,.doc,.png,.jpg'
                  className={classes.input}
                  disabled={!this.props.modoEdicaoGuia}
                  id='contained-button-file'
                  multiple
                  type='file'
                  onChange={(e) => this.handleFileSelection(e.target.files)}
                  onClick={this.handleFileClick}
                />
                <label htmlFor='contained-button-file'>
                  <Button
                    color='primary'
                    variant='contained'
                    component='span'
                    disabled={!this.props.modoEdicaoGuia}
                    className={classes.button}>
                    <FolderOpen className={classes.button} />
                    Selecione um arquivo
                  </Button>
                </label>
                {nomeArquivo &&
                <Typography className={classes.typography}>
                  {nomeArquivo}
                </Typography>}
              </div>
              <div className={classes.divBotoes}>
                <Button
                  disabled={nomeArquivo === ''}
                  color='primary'
                  variant='outlined'
                  className={classes.button}
                  onClick={this.handleClickUpload}>
                  Upload
                </Button>
              </div>
            </Paper>
            {fetching ? <LinearProgressBlockScreen />
              : <Fade timeout={1000} in>
                <Paper className={classes.body} elevation={1}>
                  <MUIDataTable
                    data={arquivos}
                    columns={columns}
                    options={options}
                  />
                </Paper>
              </Fade>}

          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogAnexarArquivos);
